const subscribeLang = {
  EMAIL: ['EMAIL', '邮箱'],
  Messenger: ['Messenger', 'Messenger'],
  ENTER_EMAIL_ADDRESS: ['ENTER EMAIL ADDRESS', '输入邮箱'],
  ENTER_NAME: ['EMTER NAME', '输入姓名'],
  DOWNLOND_CSV: ['DOWNLOND CSV', '导出'],
  EXPORT: ['EXPORT', '同步'],
  NAME: ['NAME', '姓名'],
  USER: ['USER', '用户'],
  GAME_TYPE: ['GAME NAME', '游戏'],
  COUPON_CODE: ['COUPON CODE', '折扣码'],
  REVENUE: ['REVENUE', '订单金额'],
  CREATION_TIME: ['CREATION TIME', '创建时间'],
  GENDER: ['GENDER', '性别'],
  Male: ['Male', '男'],
  Female: ['Female', '女'],
  unknown: ['unknown', '未知'],
  delete: ['delete', '删除'],
  Are_you: ['Are you sure you want to delete this item?', '你确定要删除么？'],
  export_to_shopify: ['Export To Shopify', '同步到shopify'],
  Export_Contacts: ['Export Contacts', '导出'],

  Actions: ['Actions', '操作'],
  Cancel: ['Cancel', '取消'],
  Confirm: ['confirm', '确定']
};

export default subscribeLang;
